import type { SaldoDeTanque } from './tipos';

/**
 * Para onde o combustível de um tanque pode ser transferido: os OUTROS tanques
 * do MESMO produto (decisão 6 do dono). Transferir não é abastecer máquina, e
 * diesel não vai para o tanque de ARLA — o banco confere de novo.
 */
export function destinosDaTransferencia(
  origem: SaldoDeTanque | null,
  tanques: readonly SaldoDeTanque[],
): readonly SaldoDeTanque[] {
  if (origem === null) return [];
  return tanques.filter((t) => t.id !== origem.id && t.produtoId === origem.produtoId);
}

/**
 * Por que não dá para transferir a partir deste tanque — ou `null` quando dá.
 *
 * Sem destino, o formulário não tem o que oferecer. Antes o botão continuava
 * ligado e a janela abria só com o título e o ✕, sem dizer por quê: um beco
 * sem saída. A frase diz o que falta e o que fazer.
 */
export function motivoParaNaoTransferir(
  origem: SaldoDeTanque | null,
  tanques: readonly SaldoDeTanque[],
): string | null {
  if (origem === null) return null;
  if (destinosDaTransferencia(origem, tanques).length > 0) return null;
  return `Não há outro tanque de ${origem.produto} para receber a transferência. Para transferir, cadastre o tanque que recebe na aba Cadastros.`;
}
